import React, { Component } from 'react';
import axios from 'axios';
import {isNumber} from 'utils/IsNumber.js';
import ethereum from 'decentralized/ethereum.js';
import Sample from 'repos/Sample.js';
import { Badge, Label, Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';

class SoundTagEditor extends Component {

    constructor(props) {
        super(props);
        this.sample = new Sample(this.props.soundId);
        this.loadTags(this.props.soundId);
        this.state = {
            name: '',
            showAddTag: false,
            id: this.props.soundId,
        };
        this.setState(this.state);
        this.loadName.bind(this);
        this.showAddTag.bind(this);
        this.loadTags.bind(this);
        this.addTag.bind(this);

    }

    showAddTag() {
        this.state['showAddTag'] = true;
        this.setState(this.state);
    }

    loadTags(id) {
        this.setState({tags : this.sample.tags});
    }

    addTag() {
        var tag = this._tag;
        var self = this;
        ethereum.tagSample(this.props.soundId, tag);
        this.setState({showAddTag: false, tags: this.state.tags.concat(tag)});
    }

    onSoundIdChange(oldSoundId, newSoundId) {
        this.state['id'] = newSoundId;
        this.setState(this.state);
        this.props.history.push('/sound/' + newSoundId);
        // update bar
    }

    loadName(name) {
        this.state['name'] = name;
        this.setState(this.state);
    }
    
    render() {
        var self = this;
        var id = this.state.id;

        let sliceTags = [];
        if (this.state.slices !== undefined) {
            console.log(this.props.selectedSlice);
            console.log(this.state.slices);
            let selected = this.state.slices.filter((s) => this.props.selectedSlice.startTime === s.startTime
                                                    && this.props.selectedSlice.endTime  === s.endTime);
            console.log('found selected slice tags = ');
            console.log(selected);
            if (selected.length > 0) {
                sliceTags = selected.map(s => s.tag);
            }
        }
        console.log('id = ' + id);
        return (<div className="tag-editor">
                <div>
                <span className="tag-editor-header">TAGS: </span>
                <Label>{this.state['name']}</Label>
                {this.state.tags != null ? this.state.tags.map((tag) => <Badge color="light">{tag}</Badge>) : ''}
                </div>
                <div className="tags">
                <Button className="add-tag-button" size="sm" color="secondary" onClick={()=>self.showAddTag()}>Add Tag</Button>
                {this.state['showAddTag'] ?
                   <InputGroup className="tag-sound-input">
                        <Input onChange={(event) => this._tag= event.target.value} placeholder="Add tag" className="tag-sound-input-box"/>
                        <InputGroupAddon addonType="append">
                        <Button onClick={() => this.addTag()} color="secondary">Add</Button>
                        </InputGroupAddon>
                        </InputGroup>
                        :
                    ''}
                </div>
                </div>);
    }
    
}

export default SoundTagEditor;
